"use client";

import type { ReactNode } from "react";
import {
  Bar,
  Cell,
  BarChart as RechartsBarChart,
  ResponsiveContainer,
} from "recharts";
import { cn } from "../../utils/cn";

export type BarChartDataPoint = {
  label: string;
  value: number;
};

export type BarChartProps = {
  data: BarChartDataPoint[];
  /** Height of the chart in pixels */
  height?: number;
  /** Inclusive start/end bar indices to highlight */
  activeRange?: [number, number];
  className?: string;
};

const fallbackHeight = 64;
const fallbackActiveRangeStart = 0;
export function BarChart(props: Readonly<BarChartProps>): ReactNode {
  const height = props.height ?? fallbackHeight;
  const activeStart = props.activeRange?.[0] ?? fallbackActiveRangeStart;
  const activeEnd = props.activeRange?.[1] ?? props.data.length - 1;

  return (
    <div className={cn("w-full", props.className)}>
      <ResponsiveContainer height={height} width="100%">
        <RechartsBarChart
          data={props.data}
          margin={{ bottom: 0, left: 0, right: 0, top: 0 }}
        >
          <Bar dataKey="value" isAnimationActive={false} radius={[2, 2, 0, 0]}>
            {props.data.map((entry, index) => (
              <Cell
                className={
                  index >= activeStart && index <= activeEnd
                    ? "text-gray-900"
                    : "text-gray-300"
                }
                fill="currentColor"
                key={`bar-${entry.label}-${index}`}
              />
            ))}
          </Bar>
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
}
